module.exports = __webpack_public_path__ + "img/chevron-down.5433a6d7.svg";